var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96731 10.528C6.67573 10.2338 6.67784 9.75889 6.97204 9.46731C7.26624 9.17573 7.74111 9.17784 8.03269 9.47204L9.78 11.235C10.4891 11.9505 10.9772 12.4413 11.3907 12.7734C11.7924 13.096 12.0504 13.2067 12.2815 13.2361C12.4266 13.2546 12.5734 13.2546 12.7185 13.2361C12.9496 13.2067 13.2076 13.096 13.6093 12.7734C14.0228 12.4413 14.5109 11.9505 15.22 11.235L16.9673 9.47204C17.2589 9.17784 17.7338 9.17573 18.028 9.46731C18.3222 9.75889 18.3243 10.2338 18.0327 10.528L16.2539 12.3227C15.584 12.9987 15.0364 13.5511 14.5485 13.9429C14.0412 14.3504 13.5263 14.6453 12.9082 14.7241C12.6371 14.7586 12.3629 14.7586 12.0918 14.7241C11.4737 14.6453 10.9588 14.3504 10.4515 13.9429C9.96359 13.5511 9.41604 12.9987 8.7461 12.3227L6.96731 10.528Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBottom);
export default __webpack_public_path__ + "static/media/chevron_bottom.881cb988fae270cd029f8c9477332541.svg";
export { ForwardRef as ReactComponent };